import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { RuleInterface } from '@vendasta/automata';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { AutomationViewService } from '../../../../../automation/automation-view.service';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { PipelineSelectorComponent } from '../../../common/shared-form-elements/pipeline-selector/pipeline-selector.component';

@Component({
  selector: 'automata-query-opportunities-panel',
  templateUrl: './change-opportunity-pipeline-stage-panel.component.html',
  styleUrls: ['./change-opportunity-pipeline-stage-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    PipelineSelectorComponent,
  ],
})
export class ChangeOpportunityPipelineStagePanelComponent extends CommonActionPanelComponent implements OnInit {
  @ViewChild('pipelineSelector', { static: false }) pipelineSelector: PipelineSelectorComponent;
  initialPipelineId: string;
  initialStageId: number;
  isNonPartnerAutomation$: Observable<boolean>;

  constructor(protected readonly automationService: AutomationViewService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isNonPartnerAutomation$ = this.automationService.isNonPartnerAutomation().pipe(
      take(1),
      tap((isNonPartnerAutomation) => {
        if (isNonPartnerAutomation) {
          // the pipeline selector is disabled for non-partner automations (templates), so complete its loading state
          this.pipelineSelectorLoaded();
        }
      }),
    );
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    this.initialStageId = jsonData.stage;
    this.initialPipelineId = jsonData.pipeline_id;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    if (this.pipelineSelector) {
      const selectedPipeline = this.pipelineSelector.getSelectedPipeline();
      jsonData.pipeline_id = selectedPipeline.pipelineId;
      jsonData.stage = selectedPipeline.stageId;
    }
    return jsonData;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    const controls = [];
    if (this.pipelineSelector) {
      controls.push(...this.pipelineSelector.getControlsToValidateOnSave());
    }
    return controls;
  }

  isFormValid(): boolean {
    let pipelineSelectorValid = true;
    if (this.pipelineSelector) {
      pipelineSelectorValid = this.pipelineSelector.isFormValid();
    }

    return pipelineSelectorValid;
  }

  pipelineSelectorLoaded(): void {
    this.savingEnabled = true;
  }
}
